import React, { Component } from "react";
import { BuildExcelDocWidget } from "../../../widgets";
import { Grid, Typography } from "@material-ui/core";
import { connect } from "react-redux";
import { StyledCard, StyledHeader } from "../../styles";
import { canCreate, selectMapKey } from "./selectors";

const reducer = "DashboardV2_reducer";

const BuildExcelDocWidgetSelectors = BuildExcelDocWidget.createSelectors(
    reducer
);

class ExcelDownloader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            toDate: false,
            fromDate: false,
        };
    }
    render() {
        return (
            <StyledCard>
                <StyledHeader>
                    <Typography variant="h5">Data Download</Typography>
                </StyledHeader>

                <>
                    <Grid
                        container
                        layout={"row"}
                        spacing={24}
                        style={{ marginTop: "20px" }}
                    >
                        {/* <NewsBroadcastWidget.view
                        selectors={NewsBroadcastSelectors}
                        lg={12}
                        md={12}
                        sm={12}
                        canCreate={this.props.canCreate}
                    />
                    <UserTotalWidget.view
                        selectors={UserTotalWidgetSelectors}
                        lg={3}
                        md={6}
                        sm={12}
                    />
                    <ReportTotalWidget.view
                        selectors={ReportTotalWidgetSelectors}
                        lg={3}
                        md={6}
                        sm={12}
                    /> */}
                        {/* <JobPackTotalWidget.view
                        selectors={JobPackTotalWidgetSelectors}
                        lg={3}
                        md={6}
                        sm={12}
                    />
                    <BuildVersionWidget.view
                        selectors={BuildVersionWidgetSelectors}
                        lg={3}
                        md={6}
                        sm={12}
                    /> */}
                        <BuildExcelDocWidget.view
                            selectors={BuildExcelDocWidgetSelectors}
                            lg={12}
                            md={12}
                            sm={12}
                        />
                        {/* <JobPackMapWidget.view
                        selectors={JobPackMapWidgetSelectors}
                        lg={6}
                        md={6}
                        sm={12}
                        mapKey={this.props.mapKey}
                    />
                    <ReportMapWidget.view
                        selectors={ReportMapWidgetSelectors}
                        lg={6}
                        md={6}
                        sm={12}
                        mapKey={this.props.mapKey}
                    /> */}
                        {/* <ActivityLogWidget.view
                        selectors={ActivityLogWidgetSelectors}
                        lg={6}
                        md={12}
                        sm={12}
                    />
                    <MessengerWidget.view
                        selectors={MessengerWidgetSelectors}
                        lg={6}
                        md={12}
                        sm={12}
                    /> */}
                    </Grid>
                </>
            </StyledCard>
        );
    }
}
export default connect((store) => {
    return {
        canCreate: canCreate(store),
        mapKey: selectMapKey(store),
    };
}, {})(ExcelDownloader);
